/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var github_com_solo$io_solo$kit_api_v1_ref_pb = require('../../../../../../../../../github.com/solo-io/solo-kit/api/v1/ref_pb.js');
var extproto_ext_pb = require('../../../../../../../../../extproto/ext_pb.js');
var validate_validate_pb = require('../../../../../../../../../validate/validate_pb.js');
goog.exportSymbol('proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder', null, global);
goog.exportSymbol('proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap', null, global);
goog.exportSymbol('proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.repeatedFields_, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_);
};
goog.inherits(proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.displayName = 'proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.repeatedFields_ = [2,6];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_ = [[1,4,10]];

/**
 * @enum {number}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorSetCase = {
  DESCRIPTOR_SET_NOT_SET: 0,
  PROTO_DESCRIPTOR: 1,
  PROTO_DESCRIPTOR_BIN: 4,
  PROTO_DESCRIPTOR_CONFIG_MAP: 10
};

/**
 * @return {proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorSetCase}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getDescriptorSetCase = function() {
  return /** @type {proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorSetCase} */(jspb.Message.computeOneofCase(this, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.toObject = function(opt_includeInstance) {
  return proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.toObject = function(includeInstance, msg) {
  var f, obj = {
    protoDescriptor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    protoDescriptorBin: msg.getProtoDescriptorBin_asB64(),
    protoDescriptorConfigMap: (f = msg.getProtoDescriptorConfigMap()) && proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.toObject(includeInstance, f),
    servicesList: jspb.Message.getRepeatedField(msg, 2),
    printOptions: (f = msg.getPrintOptions()) && proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.toObject(includeInstance, f),
    matchIncomingRequestRoute: jspb.Message.getFieldWithDefault(msg, 5, false),
    ignoredQueryParametersList: jspb.Message.getRepeatedField(msg, 6),
    autoMapping: jspb.Message.getFieldWithDefault(msg, 7, false),
    ignoreUnknownQueryParameters: jspb.Message.getFieldWithDefault(msg, 8, false),
    convertGrpcStatus: jspb.Message.getFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder;
  return proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProtoDescriptor(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setProtoDescriptorBin(value);
      break;
    case 10:
      var value = new proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap;
      reader.readMessage(value,proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.deserializeBinaryFromReader);
      msg.setProtoDescriptorConfigMap(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addServices(value);
      break;
    case 3:
      var value = new proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions;
      reader.readMessage(value,proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.deserializeBinaryFromReader);
      msg.setPrintOptions(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMatchIncomingRequestRoute(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addIgnoredQueryParameters(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoMapping(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreUnknownQueryParameters(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConvertGrpcStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getProtoDescriptorConfigMap();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.serializeBinaryToWriter
    );
  }
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPrintOptions();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.serializeBinaryToWriter
    );
  }
  f = message.getMatchIncomingRequestRoute();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIgnoredQueryParametersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getAutoMapping();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getIgnoreUnknownQueryParameters();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getConvertGrpcStatus();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.displayName = 'proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    addWhitespace: jspb.Message.getFieldWithDefault(msg, 1, false),
    alwaysPrintPrimitiveFields: jspb.Message.getFieldWithDefault(msg, 2, false),
    alwaysPrintEnumsAsInts: jspb.Message.getFieldWithDefault(msg, 3, false),
    preserveProtoFieldNames: jspb.Message.getFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions;
  return proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddWhitespace(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlwaysPrintPrimitiveFields(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlwaysPrintEnumsAsInts(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreserveProtoFieldNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddWhitespace();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAlwaysPrintPrimitiveFields();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAlwaysPrintEnumsAsInts();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPreserveProtoFieldNames();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool add_whitespace = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.getAddWhitespace = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.setAddWhitespace = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool always_print_primitive_fields = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.getAlwaysPrintPrimitiveFields = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.setAlwaysPrintPrimitiveFields = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool always_print_enums_as_ints = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.getAlwaysPrintEnumsAsInts = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.setAlwaysPrintEnumsAsInts = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool preserve_proto_field_names = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.getPreserveProtoFieldNames = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions.prototype.setPreserveProtoFieldNames = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.displayName = 'proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.toObject = function(opt_includeInstance) {
  return proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    configMapRef: (f = msg.getConfigMapRef()) && github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef.toObject(includeInstance, f),
    key: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap;
  return proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef;
      reader.readMessage(value,github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef.deserializeBinaryFromReader);
      msg.setConfigMapRef(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigMapRef();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef.serializeBinaryToWriter
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional core.solo.io.ResourceRef config_map_ref = 1;
 * @return {?proto.core.solo.io.ResourceRef}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.getConfigMapRef = function() {
  return /** @type{?proto.core.solo.io.ResourceRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef, 1));
};


/** @param {?proto.core.solo.io.ResourceRef|undefined} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.setConfigMapRef = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.clearConfigMapRef = function() {
  this.setConfigMapRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.hasConfigMapRef = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string key = 2;
 * @return {string}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string proto_descriptor = 1;
 * @return {string}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getProtoDescriptor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setProtoDescriptor = function(value) {
  jspb.Message.setOneofField(this, 1, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_[0], value);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.clearProtoDescriptor = function() {
  jspb.Message.setOneofField(this, 1, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.hasProtoDescriptor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes proto_descriptor_bin = 4;
 * @return {!(string|Uint8Array)}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getProtoDescriptorBin = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes proto_descriptor_bin = 4;
 * This is a type-conversion wrapper around `getProtoDescriptorBin()`
 * @return {string}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getProtoDescriptorBin_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getProtoDescriptorBin()));
};


/**
 * optional bytes proto_descriptor_bin = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getProtoDescriptorBin()`
 * @return {!Uint8Array}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getProtoDescriptorBin_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getProtoDescriptorBin()));
};


/** @param {!(string|Uint8Array)} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setProtoDescriptorBin = function(value) {
  jspb.Message.setOneofField(this, 4, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_[0], value);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.clearProtoDescriptorBin = function() {
  jspb.Message.setOneofField(this, 4, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.hasProtoDescriptorBin = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DescriptorConfigMap proto_descriptor_config_map = 10;
 * @return {?proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getProtoDescriptorConfigMap = function() {
  return /** @type{?proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap} */ (
    jspb.Message.getWrapperField(this, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap, 10));
};


/** @param {?proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.DescriptorConfigMap|undefined} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setProtoDescriptorConfigMap = function(value) {
  jspb.Message.setOneofWrapperField(this, 10, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.oneofGroups_[0], value);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.clearProtoDescriptorConfigMap = function() {
  this.setProtoDescriptorConfigMap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.hasProtoDescriptorConfigMap = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated string services = 2;
 * @return {!Array<string>}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getServicesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setServicesList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.addServices = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.clearServicesList = function() {
  this.setServicesList([]);
};


/**
 * optional PrintOptions print_options = 3;
 * @return {?proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getPrintOptions = function() {
  return /** @type{?proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions} */ (
    jspb.Message.getWrapperField(this, proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions, 3));
};


/** @param {?proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.PrintOptions|undefined} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setPrintOptions = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.clearPrintOptions = function() {
  this.setPrintOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.hasPrintOptions = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool match_incoming_request_route = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getMatchIncomingRequestRoute = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setMatchIncomingRequestRoute = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string ignored_query_parameters = 6;
 * @return {!Array<string>}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getIgnoredQueryParametersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setIgnoredQueryParametersList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.addIgnoredQueryParameters = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.clearIgnoredQueryParametersList = function() {
  this.setIgnoredQueryParametersList([]);
};


/**
 * optional bool auto_mapping = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getAutoMapping = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setAutoMapping = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool ignore_unknown_query_parameters = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getIgnoreUnknownQueryParameters = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setIgnoreUnknownQueryParameters = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool convert_grpc_status = 9;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.getConvertGrpcStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.grpc_json.options.gloo.solo.io.GrpcJsonTranscoder.prototype.setConvertGrpcStatus = function(value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};


goog.object.extend(exports, proto.grpc_json.options.gloo.solo.io);
